module.exports = new __parcel__URL__("security-preview.5dc5fb3a.svg").toString();